import axios from "axios";
// import { clear, coldError, errorMsg } from "../reducers/snackMsgsReducers";
import { normalize } from "normalizr";
// import i18n from "i18n";
import { traceError } from "../../helpers/utilities";

const apiMiddleware =
	({ dispatch, getState }) =>
	next =>
	action => {
		if (!action) {
			return;
		}
		if (Array.isArray(action)) {
			action.forEach(obj => obj && dispatch(obj));
			return;
		}
		next(action);

		if (!action?.payload?.requestUrl) return;

		let {
			isCustomUrl,
			requestUrl: url,
			method,
			schema,
			data,
			onLoading,
			onSuccess,
			onFailure,
			headers,
			withCredentials
		} = action.payload;
		const dataOrParams = ["GET", "DELETE"].includes(method) ? "params" : "data";

		// axios default configs
		axios.defaults.baseURL = process.env.REACT_APP_AMBACK || "";
		axios.defaults.headers.common["Content-Type"] = "application/json";

		// dispatch(clear());

		const user = getState()?.userStatus?.auth?.user;

		if (user && !headers && !isCustomUrl) {
			headers = {
				Authorization: `Bearer ${user.token}`,
				UserEmail: user.email
			};
		}

		headers.AssistantID = user.assistantID;
		headers.language = user?.language || "FR";

		if (onLoading) {
			dispatch(onLoading(true));
		}
		axios
			.request({
				url,
				method,
				headers,
				[dataOrParams]: data,
				withCredentials
			})
			.then(({ data }) => {
				if (schema) {
					dispatch(onSuccess(normalize(data, schema)));
				} else {
					dispatch(onSuccess(data));
				}
			})
			.catch(error => {
				if (typeof onFailure === "function") {
					let errMsg;
					try {
						errMsg = JSON.stringify(data);
					} catch (error) {
						errMsg = ">cannot stringify the data<";
					}
					traceError(`apiMiddleware-${error.message}, url: ${url}, data: ${errMsg}`);

					dispatch(onFailure(error));
					//LOOK FOR ERROR
					// if (error.message === "Network Error") {
					// 	dispatch(errorMsg(i18n.t("api.networkError"), error));
					// } else {
					// 	dispatch(onFailure(error));
					// }
				}
			})
			.then(() => {
				if (onLoading) {
					dispatch(onLoading(false));
				}
			});
	};

export default apiMiddleware;
